module.exports = __webpack_public_path__ + "media/images/product/p_y-4e99ff135b11200ddca0a914002bb0e3.png";